import { Component, OnInit } from '@angular/core';
// import { ActivatedRoute } from '@angular/router';
// import { environment } from '../../environments/environment';
//
// import { Programacion } from '../models/programacion';
// import { ProgramacionService } from '../services/programacion.service';
@Component({
  selector: 'app-programacion',
  templateUrl: './programacion.component.html',
  styleUrls: ['./programacion.component.css']
})
export class ProgramacionComponent implements OnInit {
  //
  //
  // model: Programacion = new Programacion();
  // url = environment.imgUrl;

  constructor() {
    //this.model.id = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit() {
    // this.modelService.get(this.model.id).subscribe(val => {
    //   this.model = val;
    // });
  }
}
